'use client';

import useWebInstance from '@/grandus-lib/hooks/useWebInstance';
import Image from '@/grandus-utils/wrappers/image/Image';

const PlaceholderImage = (props) => {
  const { webInstance } = useWebInstance();

  if (!webInstance?.placeholder) {
    return '';
  }

  return <Image
    photo={webInstance?.placeholder}
    {...props}
  />;
};

export default PlaceholderImage;